<template>
  <div>
    <ViewTemplateReportList :panel="panel" :reports="reports" />
  </div>
</template>

<script>
import ViewTemplateReportList from "@nixweb/nixloc-ui/src/component/template/ViewTemplateReportList";

export default {
  name: "RelatorioCrmView",
  components: { ViewTemplateReportList },
  data() {
    return {
      panel: {
        module: "Cliente",
        title: "Relatório",
        showFilter: false,
        showSearch: true,
        showButtons: false,
      },
      reports: {
        default: [
          {
            name: "Cliente",
            routeName: "reportCrmCustomer",
          },
          {
            name: "Contato",
            routeName: "reportCrmContact",
          },
        ],
        saved: [],
      },
    };
  },
};
</script>
